/**
 * WebSocket Configuration Constants
 * Centralized configuration for Open Natter WebSocket connection
 */

export const WEBSOCKET_CONFIG = {
  /** Delay before attempting to reconnect after connection loss (ms) */
  RECONNECT_DELAY_MS: 2_000,

  /** Expected interval for incoming heartbeats from server (ms) */
  HEARTBEAT_INCOMING_MS: 25_000,

  /** Interval for sending heartbeats to server (ms) */
  HEARTBEAT_OUTGOING_MS: 25_000,

  /** Maximum number of reconnection attempts before giving up */
  MAX_RECONNECT_ATTEMPTS: 5,
} as const;

/**
 * Join/Retry Configuration Constants
 * Used by listener middleware for join timeout and retry logic
 */
export const JOIN_RETRY_CONFIG = {
  /** Maximum number of join attempts */
  MAX_ATTEMPTS: 3,

  /** Base timeout for first attempt (ms) - multiplied by attempt number */
  BASE_TIMEOUT_MS: 5_000,

  /** Delay between retry attempts (ms) */
  RETRY_DELAY_MS: 500,
} as const;

/**
 * Mark Ready Configuration Constants
 */
export const MARK_READY_CONFIG = {
  /** Timeout for waiting for phase change after mark ready (ms) */
  TIMEOUT_MS: 10_000,
} as const;
